export enum ShareMediaServicesPref {
	ENABLED = 'mediaServices.enabled',
}
